import React from 'react'
import classNames from 'classnames'
import type moment from 'moment'
import { DAY_NAMES } from './dateUtils'
import type { usePainterScheduleLayoutStyles } from './usePainterScheduleLayoutStyles'

interface DayStripProps {
  weekDays: moment.Moment[]
  selectedDay: moment.Moment
  daysWithEvents: Set<string>
  onSelectDay: (day: moment.Moment) => void
  classes: ReturnType<typeof usePainterScheduleLayoutStyles>
}

export default function DayStrip({ weekDays, selectedDay, daysWithEvents, onSelectDay, classes }: DayStripProps) {
  return (
    <div className={classes.dayStripSection}>
      <div className={classes.dayStrip}>
        {weekDays.map((day) => {
          const isSelected = day.isSame(selectedDay, 'day')
          const hasEvent = daysWithEvents.has(day.format('YYYY-MM-DD'))
          return (
            <button
              key={day.format('YYYY-MM-DD')}
              type="button"
              className={classNames(classes.dayButton, isSelected && classes.dayButtonSelected)}
              onClick={() => onSelectDay(day)}
              aria-label={day.format('dddd MMMM D')}
              aria-pressed={isSelected}
            >
              <div className={classes.dayContent}>
                <span className={classNames(classes.dayName, isSelected && classes.dayNameSelected)}>
                  {DAY_NAMES[day.day()]}
                </span>
                <span className={classNames(classes.dayNumber, isSelected && classes.dayNumberSelected)}>
                  {day.format('D')}
                </span>
              </div>
              {hasEvent && <span className={classNames(classes.dayDot, isSelected && classes.dayDotSelected)} />}
            </button>
          )
        })}
      </div>
    </div>
  )
}
